import React from "react";

export function SVGGroup(props) {
  return <g>{props.children}</g>;
}
